export const isOnline = () => {
  if (localStorage.isConnect === 'false') {
    return false;
  }
  return true;
};
